<template>
  <div>
    <header class="d-sm-flex align-items-baseline">
      <h2 class="mr-auto" v-html="name"></h2>
      <Breadcrumbs></Breadcrumbs>
    </header>
  </div>
</template>

<script>

import Breadcrumbs from '@/components/Breadcrumbs'
export default {
  components: {
    Breadcrumbs
  },
  name: 'ContentHeader',
  props: ['name']
}
</script>



// WEBPACK FOOTER //
// src/components/ContentHeader.vue